import React, { FC } from 'react';
import classes from './BasicCard.module.css';

type BasicCardProps = {
  title: string;
  text: string;
  clickHandler?: () => any;
  className?: string;
  grayMode?: boolean;
};

const BasicCard: FC<BasicCardProps> = ({
  title,
  text,
  clickHandler,
  className,
  grayMode,
}) => {
  const classesList = [
    grayMode ? classes.BasicCardGray : classes.BasicCard,
    className,
  ];
  return (
    <div onClick={clickHandler} className={classesList.join(' ')}>
      <div className={grayMode ? classes.titleGray : classes.title}>
        {title}
      </div>
      <div className={grayMode ? classes.textGray : classes.text}>{text}</div>
    </div>
  );
};

export default BasicCard;
